module.exports = __webpack_public_path__ + "img/RW.f7bc5c5e.png";